import { Button, ButtonProps, Typography } from "@material-ui/core"
import { KeyboardArrowLeft } from "@material-ui/icons"
import { useIsDesktop } from "common/MediaQueries"
import {
  trackAddToCart,
  trackCheckoutStepWithComponents,
} from "common/analytics"
import { useLayoutContext } from "layout/oldLayout/LayoutContext"
import React from "react"
import { Link, LinkProps, useLocation } from "react-router-dom"
import routes from "routes"
import { useTypedSelector } from "store"
import styled from "styled-components"
import useInStock from "../useInStock"
import { selectedComponentsForAnalyticsSelector } from "../wizardSelectors"

const StyledDesktopContainer = styled.div``

const StyledKeyboardArrowLeftIcon = styled(KeyboardArrowLeft)`
  position: relative;
  color: ${(p) => p.theme.colors.white};
  margin-left: -6px;
  font-size: 15px;
`

type StyledButtonLinkProps = React.FC<ButtonProps & LinkProps>

const StyledButtonLink = styled<StyledButtonLinkProps>(Button).attrs({
  component: Link,
})`
  background: ${(p) => p.theme.colors.black};
  color: ${(p) => p.theme.colors.white};
  border-radius: 3px;

  :hover {
    background: ${(p) => p.theme.colors.steel};
    border-color: ${(p) => p.theme.colors.steel};
  }
  &.Mui-disabled {
    color: ${(p) => p.theme.colors.white};
    opacity: 0.5;
    cursor: not-allowed;
  }
`

const NextStepButton = () => {
  const isDesktop = useIsDesktop()
  const { pathname } = useLocation()
  const activeStepIndex = routes.array.findIndex((r) => r.path === pathname)
  const nextStep = routes.array[activeStepIndex + 1]

  const { showOnlyStock } = useTypedSelector((state) => state.wizard)
  const inStock = useInStock()

  const selectedComponentsForAnalytics = useTypedSelector(
    selectedComponentsForAnalyticsSelector
  )

  const { focusMain } = useLayoutContext()

  const Container = isDesktop ? StyledDesktopContainer : React.Fragment
  // const mounted = useMounted()

  if (!nextStep) return null

  const sendEvent = () => {
    if (selectedComponentsForAnalytics) {
      trackAddToCart(selectedComponentsForAnalytics)
      trackCheckoutStepWithComponents(selectedComponentsForAnalytics)
    }
  }

  return (
    <Container>
      <StyledButtonLink
        onClick={() => {
          nextStep.path === routes.summary.path && sendEvent()
          focusMain()
        }}
        variant="outlined"
        color="primary"
        to={nextStep.path}
        role="link"
        disabled={!inStock && showOnlyStock}
      >
        <Typography variant="srOnly">לשלב הבא,</Typography>

        {nextStep.path === routes.summary.path
          ? `ל${nextStep.title}`
          : `לבחירת ${nextStep.title}`}
        <StyledKeyboardArrowLeftIcon />
      </StyledButtonLink>
    </Container>
  )
}

export default NextStepButton
